export const AID_FETCH = 'AID_FETCH'
export const AID_CREATE = 'AID_CREATE'
export const AID_UPDATE = 'AID_UPDATE'
